var ProductSearch = (function ($, document) {
    'use strict';

    function ProductSearch(config) {
        this.$search = $('#product-search');
        this.$searchInput = $('#product-search-input');
        this.$searchInputGroup = this.$search.find('> .input-group');
        this.$searchPlatforms = $('#product-search-platforms');
        this.$suggestions = this.$search.find('> .dropdown-menu');
        this.$noResults = Handlebars.compile( $('#product-search-no-results-template').html() );
        this.$siblingsMenu = $('#product-search').parent().find('.dropdown-mobile .navbar-right');
        this.config = $.extend({}, this.getDefaultConfig(), config);
        this.currentValue = '';
        this.selectedPlatform = '';
        this.onChangeInterval = undefined;
        this.request = undefined;

        this.keys = {
            ESC: 27,
            TAB: 9,
            RETURN: 13,
            LEFT: 37,
            UP: 38,
            RIGHT: 39,
            DOWN: 40
        };

        this.loadEvents();
    }

    ProductSearch.prototype = {
        getDefaultConfig: function () {
            var noop = function () {};

            return {
                timeout: 250,
                beforeRequest: noop,
                onFailure: noop,
                onComplete: noop
            };
        },

        getConfig: function () {
            return this.config;
        },

        loadEvents: function () {
            var self = this;

            this.$searchInput.on('keydown', function (e) {
                if (e.which === self.keys.RETURN) {
                    e.preventDefault();
                    return false;
                }
            });

            this.$searchInput.on('keyup', function (e) {
                switch (e.which) {
                    case self.keys.UP:
                    case self.keys.DOWN:
                        e.preventDefault();
                        return false;
                }

                if (self.onChangeInterval) {
                    clearInterval(self.onChangeInterval);
                }

                if (self.currentValue !== self.$searchInput.val()) {
                    if (self.config.timeout > 0) {
                        self.onChangeInterval = setInterval(function () {
                            self.onValueChange();
                        }, self.config.timeout);
                    } else {
                        self.onValueChange();
                    }
                }
            });

            this.$search.find('> a').on('click', function (e) {
                self.active();

                e.preventDefault();
            });

            this.$searchInputGroup.find('> a').on('click', function (e) {
                self.deactive();

                e.preventDefault();
            });

            this.$searchPlatforms.on('shown.bs.dropdown', function () {
                self.close();
            });

            this.$searchPlatforms.on('click', '.product-search-platform', function (e) {
                self.$searchPlatforms.find('.product-search-platform').removeClass('active');

                var $platform = $(this).find('> a').addClass('active');

                self.selectedPlatform = $platform.data('id');
                self.setPlatformLabel( $platform.text() );
                self.onValueChange();

                e.preventDefault();
            });

            $(document).on('click touchstart', function (e) {
                if ( ! self.$search.find('> .dropdown-menu').has(e.target).length) {
                    self.close();
                }
            });

            $(document).on('click touchstart', function (e) {
                if ( ! self.$search.has(e.target).length) {
                    self.deactive();
                }
            });

        },

        open: function() {
            this.$search.addClass('open');

        },

        close: function() {
            this.$search.removeClass('open');

        },

        active: function() {
            this.$searchInputGroup.addClass('active');
            this.$siblingsMenu.addClass('hidden');
            this.$searchInput.focus();
        },

        deactive: function() {
            this.$searchInputGroup.removeClass('active');
            this.$siblingsMenu.removeClass('hidden');
            this.$searchInput.prop('value', '');
        },

        getUrl: function () {
            return this.$search.data('url');
        },

        getValue: function() {
            return this.$searchInput.val().replace(/(<([^>]+)>)/ig, '');
        },

        setPlatformLabel: function(label) {
            this.$searchPlatforms.find('.product-search-selected-platform').text(label);
        },

        onValueChange: function () {
            var
                self = this,
                value = this.getValue(),
                params = {
                    platform: self.selectedPlatform,
                    query: encodeURIComponent(value)
                };

            if (this.onChangeInterval) {
                clearInterval(this.onChangeInterval);
            }

            this.currentValue = value;

            if (this.request) {
                this.request.abort();
                this.request = undefined;
            }

            if(self.getValue() === '') {
                self.close();
                return false;
            }

            self.config.beforeRequest.call(self, value);

            this.request = $.post(this.getUrl(), params)
                .done(function (response) {
                    console.log(value, response);
                    self.config.onComplete.call(self, value, response);
                    self.setSuggestions(response.suggestions);
                    self.open();
                })
                .fail(function (jqXHR, textStatus, errorThrown) {
                    self.config.onFailure.call(self, value, jqXHR, textStatus, errorThrown);
                    self.close();
                });
        },

        setSuggestions: function(suggestions) {
            var items = [];

            $.each(suggestions, function() {
                items.push('<li><a href="' + this.url + '">' + this.value + '</a></li>');
            });

            this.$suggestions.html( items.join('') );

            if( ! items.length) {
                this.$suggestions.html(this.$noResults);
            }

        }

    };

    return ProductSearch;
})(jQuery, document);
